import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function UploadOrderModal({ onClose, onUpload }) {
  const [dragOver, setDragOver] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleDrop = (e) => {
    e?.preventDefault();
    setDragOver(false);
    const dropped = e?.dataTransfer?.files?.[0];
    if (dropped) setFile(dropped);
  };

  const handleFileChange = (e) => {
    if (e?.target?.files?.[0]) setFile(e?.target?.files?.[0]);
  };

  const handleUpload = () => {
    if (!file) return;
    setUploading(true);
    setTimeout(() => {
      setUploading(false);
      onUpload(file);
      onClose();
    }, 1500);
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{ backgroundColor: "rgba(17,24,39,0.5)" }}>
      <div className="bg-card border border-border rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h3 className="font-heading font-semibold text-base text-foreground flex items-center gap-2">
            <Icon name="Upload" size={18} color="var(--color-primary)" strokeWidth={2} />
            Upload Field Order
          </h3>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground transition-colors">
            <Icon name="X" size={20} color="currentColor" strokeWidth={2} />
          </button>
        </div>
        <div className="p-4 space-y-4">
          <div
            onDragOver={(e) => { e?.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={handleDrop}
            className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${dragOver ? "border-primary bg-primary/5" : "border-border"}`}
          >
            <Icon name="Camera" size={36} color="var(--color-muted-foreground)" strokeWidth={1.5} className="mx-auto mb-3" />
            <p className="font-caption text-sm text-foreground font-medium mb-1">Drop file or take photo</p>
            <p className="font-caption text-xs text-muted-foreground mb-3">Supports JPG, PNG, PDF, Excel</p>
            <label className="cursor-pointer">
              <span className="font-caption text-sm text-primary underline">Browse files</span>
              <input type="file" accept=".jpg,.jpeg,.png,.pdf,.xlsx,.xls" className="hidden" onChange={handleFileChange} />
            </label>
          </div>
          {file && (
            <div className="flex items-center gap-3 p-3 bg-muted rounded-md">
              <Icon name="FileText" size={20} color="var(--color-primary)" strokeWidth={2} />
              <div className="flex-1 min-w-0">
                <p className="font-caption text-sm text-foreground truncate">{file?.name}</p>
                <p className="font-caption text-xs text-muted-foreground">{(file?.size / 1024)?.toFixed(1)} KB</p>
              </div>
              <button onClick={() => setFile(null)} className="text-muted-foreground hover:text-destructive">
                <Icon name="X" size={16} color="currentColor" strokeWidth={2} />
              </button>
            </div>
          )}
          <div className="flex gap-3">
            <Button variant="outline" fullWidth onClick={onClose}>Cancel</Button>
            <Button variant="default" fullWidth loading={uploading} disabled={!file} iconName="Upload" iconPosition="left" iconSize={15} onClick={handleUpload}>
              {uploading ? "Processing..." : "Upload Order"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}